import {css} from '@emotion/core'
import styled from '@emotion/styled'
import { gray, backgroundGray } from '@css/constants'

export const CheckboxWrapper = styled('div')<{
  selected: boolean
}>(props => css`
  padding: 18px 24px;
  border: 1px solid ${gray};
  background: ${props.selected ? backgroundGray : 'transparent'};
  border-radius: 2px;
`)
